<div class="grid col-12">
  <div class="col-4">
    <p-dropdown [options]="displayList" [readonly]="false" [(ngModel)]="selectedDisplay" 
      scrollHeight="75vh"
      (onChange)="onChange($event)" placeholder="{{'Sel_TyDisp' | translate}}" filter="true">
  </p-dropdown>
  </div>
  @if (selectedDisplay !== -1) {
    <p-button class="marg-top" label="{{'Save_Pos' | translate}}" (onClick)="savePos(true,'')"></p-button>
    @if (selectedDisplay !== 0) {
      <p-button class="margin-left marg-top" label="{{'Dock_Mod_Add' | translate}}" (onClick)="addMod()"></p-button>
    }
    @if (customModel === true && selectedDisplay !== -1) {
      <p-button class="margin-left marg-top" label="{{'Dock_Mod_Del' | translate}}" styleClass="p-button-danger" (onClick)="delMod()"></p-button>
    }    
    <p-button class="margin-left marg-top" label="{{'Dock_Dock_Add' | translate}}" (onClick)="addDock()"></p-button>
    @if (selectedDisplay === 0) {
      <p-button class="margin-left marg-top" label="{{'Apply_Dock_Det' | translate}}" (onClick)="applyDetail()"></p-button>
    }
    @if (selectedDisplay !== 0) {
      <p-button class="margin-left marg-top" label="{{'Apply_Bsk' | translate}}" (onClick)="applyBsk()"></p-button>      
    }
  }
</div>

<div style="height: 100%;">
  <gridster class="back-grd"  id='dashboard_b' [options]="options">
    @for (item of dockBase; track item) {
      <gridster-item [item]="item"
        class="gridster-item-content col-12 inherit back-grd-item"
        [ngClass]="{'gridster-item-reorg': options.draggable.enabled === true}">
        @switch (item.id) {
          @case ('dockReorg') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Reorder' | translate}}</div>
            <div class="flex align-items-end">
              <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
              <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
              <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
              <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
              <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
              <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
              <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
              <p-skeleton size="2rem" styleClass="mr-2"></p-skeleton>
              <p-skeleton size="2rem" styleClass="mr-2"></p-skeleton>
              <p-skeleton size="2rem" styleClass="mr-2"></p-skeleton>
            </div>          
          }       
          @case ('dockVisu') {
          <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Doc_B' | translate}}</div>
          }
          @case ('dockAtf') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Atf' | translate}}</div>
            <p-skeleton styleClass="mb-2" height="4rem"></p-skeleton>
            <p-table [value]="lines" responsiveLayout="scroll">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{'File' | translate}}</th>
                  <th>{{'Atf' | translate}}</th>
                  <th>{{'Date' | translate}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td><p-skeleton></p-skeleton></td>
                  <td><p-skeleton></p-skeleton></td>
                  <td><p-skeleton></p-skeleton></td>
                </tr>
              </ng-template>
            </p-table>
          }
          @case ('dockComment') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Comm' | translate}}</div>
            <p-skeleton styleClass="mb-2" height="8rem"></p-skeleton>
            <p-table [value]="lines" responsiveLayout="scroll">
              <ng-template pTemplate="header">
                <tr>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td><p-skeleton></p-skeleton></td>
                </tr>
              </ng-template>
            </p-table>
          }
          @case ('dockVersion') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Versions' | translate}}</div>
            <p-table [value]="lines" responsiveLayout="scroll">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{'Versions' | translate}}</th>
                  <th>{{'Date' | translate}}</th>
                  <th>{{'Action' | translate}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td><p-skeleton></p-skeleton></td>
                  <td><p-skeleton></p-skeleton></td>
                  <td><p-skeleton></p-skeleton></td>
                </tr>
              </ng-template>
            </p-table>
          }
          @case ('dockVar') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Variable' | translate}}</div>
            <p-table [value]="lines" responsiveLayout="scroll">
              <ng-template pTemplate="header">
                <tr>
                  <th></th>
                  <th></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td><p-skeleton></p-skeleton></td>
                  <td><p-skeleton></p-skeleton></td>
                </tr>
              </ng-template>
            </p-table>
          }
          @case ('dockBskMove') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Trs_Bsk' | translate}}</div>
            <p-table [value]="lines" responsiveLayout="scroll">
              <ng-template pTemplate="header">
                <tr>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td><p-skeleton></p-skeleton></td>
                </tr>
              </ng-template>
            </p-table>
          }
          @case ('dockList') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Baskets' | translate}}</div>
            <p-table [value]="lines" responsiveLayout="scroll">
              <ng-template pTemplate="header">
                <tr>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td><p-skeleton></p-skeleton></td>
                </tr>
              </ng-template>
            </p-table>
          }
          @case ('dockInfos') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Infos' | translate}}</div>
            <p-table [value]="lines" responsiveLayout="scroll">
              <ng-template pTemplate="header">
                <tr>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td><p-skeleton></p-skeleton></td>
                </tr>
              </ng-template>
            </p-table>
          }
          @case ('dockTrace') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Trace' | translate}}</div>
            <p-table [value]="lines" responsiveLayout="scroll">
              <ng-template pTemplate="header">
                <tr>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td><p-skeleton></p-skeleton></td>
                </tr>
              </ng-template>
            </p-table>
          }
          @case ('dockIndex') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Index' | translate}}</div>
            <p-table [value]="lines" responsiveLayout="scroll">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{'Variable' | translate}}</th>
                  <th>{{'Ent_Data' | translate}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td><p-skeleton></p-skeleton></td>
                  <td><p-skeleton></p-skeleton></td>
                </tr>
              </ng-template>
            </p-table>
          }
          @case ('dockButton') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Actions' | translate}}</div>
            <p-skeleton styleClass="mb-2" height="3rem"></p-skeleton>
          }
          @case ('dockMail') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Mail_Info' | translate}}</div>
            <p-skeleton styleClass="mb-2" height="10rem"></p-skeleton>
          }
          @case ('invoicevalidation') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Val_Fac' | translate}}</div>
            <p-table [value]="lines" responsiveLayout="scroll">
              <ng-template pTemplate="header">
                <tr>
                  <th></th>
                  <th></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td><p-skeleton></p-skeleton></td>
                  <td><p-skeleton></p-skeleton></td>
                </tr>
              </ng-template>
            </p-table>
          }
          @case ('maildispatching') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Mail_Dist' | translate}}</div>
            <p-skeleton styleClass="mb-2" height="2rem"></p-skeleton>
            <p-skeleton styleClass="mb-2" height="2rem"></p-skeleton>
            <p-table [value]="lines" responsiveLayout="scroll">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{'User_1' | translate}}</th>
                  <th>{{'UsersD_1' | translate}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td><p-skeleton></p-skeleton></td>
                  <td><p-skeleton></p-skeleton></td>
                </tr>
              </ng-template>
            </p-table>
          }
          @case ('mailreordering') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Reor_Mail' | translate}}</div>
            <p-skeleton styleClass="mb-2" height="2rem"></p-skeleton>
            <p-skeleton styleClass="mb-2" height="2rem"></p-skeleton>
            <p-table [value]="lines" responsiveLayout="scroll">
              <ng-template pTemplate="header">
                <tr>
                  <th></th>
                  <th></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td><p-skeleton></p-skeleton></td>
                  <td><p-skeleton></p-skeleton></td>
                </tr>
              </ng-template>
            </p-table>
          }
          @case ('mailvalidation') {
            <div style="text-align:center; width: 100%; height: 2rem; background-color: lightskyblue; margin-bottom: 5px;">{{'Val_Mail' | translate}}</div>
            <div>{{'Dock_Custom' | translate}}</div>
            <p-skeleton styleClass="mb-2" height="2rem"></p-skeleton>
            <p-skeleton styleClass="mb-2" height="2rem"></p-skeleton>
            <p-skeleton styleClass="mb-2" height="2rem"></p-skeleton>
          }
          @default {
            <div style="display: flex;">
              <div style="text-align:center; height: 2rem; background-color: lightskyblue; margin-bottom: 5px; padding-top: 5px; flex-basis: 100%;">{{item.id}}</div>
              <div class="nopad" style="flex-basis: max-content;">
                <i
                  class="icons8-trash-can iconstyle" style="text-align:center; padding: initial;"
                  (click)="deleteDock(item)"
                  style="color:red;"
                ></i>
              </div>
            </div>
          }
        }
      </gridster-item>
    }
  </gridster>
</div>

<p-dialog
  [contentStyle]="{ overflow: 'auto' }"
  [styleClass]="'sm:col-12 md:col-6 lg:col-4 xl:col-4'"
  [(visible)]="displayName"
  [modal]="true"
  [closable]="true"
  >
  <ng-template pTemplate="header">
    <span class="p-dialog-title">
      {{'Dock_Mod_Name' | translate}}
    </span>
  </ng-template>
  <div class="col-12">
    <input
      [(ngModel)]="modelName"
      class="p-inputtext size_cent"
      pInputText
      type="text"
      maxlength="64"
      autofocus
      />
    </div>
    <div class="col-12 md:col-12 align-right">
      <button type="button" pButton class="margin p-button-primary p-button-outlined" (click)="closeSave()" label="{{'Cancel' | translate}}"></button>
      <button type="button" pButton class="margin" (click)="onSave(true)" label="{{'Save' | translate}}"></button>
    </div>
</p-dialog>

<p-dialog
  [contentStyle]="{ overflow: 'auto' }"
  [styleClass]="'sm:col-12 md:col-6 lg:col-4 xl:col-4'"
  [(visible)]="displayDock"
  [modal]="true"
  [closable]="true"
  >
  <ng-template pTemplate="header">
    <span class="p-dialog-title">
      {{'Dock_List' | translate}}
    </span>
  </ng-template>
  <div class="col-12">
    @if (dockList.length !== 0) {
      <p-listbox [readonly]="readOnly" [options]="dockList"  [(ngModel)]="selectedDock"  [metaKeySelection]="false" [checkbox]="true" 
      [filter]="true" optionLabel="label" [multiple]="true" optionValue="name"  [listStyle]="{'max-height':'400px'}" [style]="{'width':'100%'}">
        <ng-template let-dock pTemplate="item">
          <div>{{dock.label}}</div>
        </ng-template>
      </p-listbox>
    }
  </div>
  <ng-template pTemplate="footer">
    <div class="col-12 md:col-12 align-right">
      <button type="button" pButton class="margin p-button-primary p-button-outlined" (click)="closeAddDock()" label="{{'Cancel' | translate}}"></button>
      <button type="button" pButton class="margin" (click)="onAddDock()" label="{{'Valid' | translate}}"></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [contentStyle]="{ overflow: 'auto' }"
  [styleClass]="'sm:col-12 md:col-6 lg:col-4 xl:col-4'"
  [(visible)]="displayBsk"
  [modal]="true"
  [closable]="true"
  >
  <ng-template pTemplate="header">
    <span class="p-dialog-title">
      {{'Bsk_List' | translate}}
    </span>
  </ng-template>
  <div class="col-12">
    @if (basketList.length !== 0) {
      <bskselect
        #bskselect
        [basketList]="basketList"
      >
      </bskselect>   
    }
  </div>
  <ng-template pTemplate="footer">
    <div class="col-12 md:col-12 align-right">
      <button type="button" pButton class="margin p-button-primary p-button-outlined" (click)="closeApplyBsk()" label="{{'Cancel' | translate}}"></button>
      <button type="button" pButton class="margin" (click)="onApplyBsk(true)" label="{{'Save' | translate}}"></button>
    </div>
  </ng-template>
</p-dialog>
